import * as state from './state.js';
import { showToast } from './dom.js';
import { getDoc } from './editor-view.js';

export function compressYaml(yaml) {
    if (typeof window.pako === 'undefined') {
        throw new Error('pako library not loaded');
    }
    const compressed = window.pako.deflate(yaml, { level: 9 });
    let base64 = btoa(String.fromCharCode.apply(null, compressed));
    base64 = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return base64;
}

export function decompressYaml(encoded) {
    if (typeof window.pako === 'undefined') {
        throw new Error('pako library not loaded');
    }
    let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
        base64 += '=';
    }
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return window.pako.inflate(bytes, { to: 'string' });
}

export function updateUrlParams({ push = false } = {}) {
    const exampleSelector = document.getElementById('example-selector');
    const formatSelector = document.getElementById('format-selector');
    const params = new URLSearchParams();

    // Preserve the active project across example/format/vars changes — it
    // selects which project's registry the render hits.
    const project = state.activeProject();
    if (project) {
        params.set('project', project);
    }

    if (exampleSelector.value) {
        params.set('example', exampleSelector.value);
    }

    const format = formatSelector.value;
    if (format && format !== 'svg') {
        params.set('f', format);
    }

    if (Object.keys(state.currentVariables).length > 0) {
        params.set('vars', JSON.stringify(state.currentVariables));
    }

    const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;

    if (push) {
        window.history.pushState({}, '', newUrl);
    } else {
        window.history.replaceState({}, '', newUrl);
    }
}

export function initShareLink() {
    const shareBtn = document.getElementById('share-btn');

    if (shareBtn) {
        shareBtn.addEventListener('click', async () => {
            const yaml = getDoc(state.editor);
            if (!yaml.trim()) {
                showToast('Please enter some YAML first');
                return;
            }

            let shareUrl;
            try {
                const compressedYaml = compressYaml(yaml);
                const format = document.getElementById('format-selector').value;
                shareUrl = `${window.location.origin}${window.location.pathname}?y=${compressedYaml}`;
                if (format && format !== 'svg') {
                    shareUrl += `&f=${format}`;
                }
                const project = state.activeProject();
                if (project) {
                    shareUrl += `&project=${encodeURIComponent(project)}`;
                }
            } catch (compressError) {
                showToast(`Error: ${compressError.message}`);
                return;
            }

            try {
                await navigator.clipboard.writeText(shareUrl);
                window.history.pushState({}, '', shareUrl);
                showToast('Link copied!');
            } catch (error) {
                try {
                    const textArea = document.createElement('textarea');
                    textArea.value = shareUrl;
                    textArea.style.position = 'fixed';
                    textArea.style.opacity = '0';
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                    window.history.pushState({}, '', shareUrl);
                    showToast('Link copied!');
                } catch (fallbackError) {
                    showToast(`Error: ${fallbackError.message}`);
                }
            }
        });
    }

}
